import { render, staticRenderFns } from "./resource-tree.vue?vue&type=template&id=d6d9f17c&"
import script from "./resource-tree.vue?vue&type=script&lang=js&"
export * from "./resource-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "resource-tree.vue"
export default component.exports